/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* change quantity for add to cart buttons on collection page */

function decreaseQuantity(){
 	event.preventDefault();
  	if(event.target.nextElementSibling.value > 1){
    event.target.nextElementSibling.value = parseInt(event.target.nextElementSibling.value) - 1; 
  }
}

function increaseQuantity(){
 	event.preventDefault();
    event.target.previousElementSibling.value = parseInt(event.target.previousElementSibling.value) + 1;
}
$(document).ready(function() {
   // $(document).on("scroll", onScroll);

   //smoothscroll
   $('a[href^="#"]').click(function() {
      var target = $(this).attr('href');
      $('html, body').animate({
         scrollTop: $(target).offset().top - 48
      }, 500);
      return false;

      $(".product-nav a").click(function() {
         $(".product-nav a").removeClass('active');
      })
      $(this).addClass('active');

      var target = this.hash,
         menu = target;
      $target = $(target);
      $('html, body').stop().animate({
         'scrollTop': $(target).offset().top - 50
      }, 500, 'swing', function() {
         window.location.hash = target;
         // $(document).on("scroll", onScroll);
      });
   });
});
setTimeout(function(){
  $(".ProductItem  .ProductItem__Wrapper").each(function(){
    $(".ProductItem  .ProductItem__Wrapper").css("height","auto");
    var e=-1;
    $(".ProductItem  .ProductItem__Wrapper").each(function(){
      var t=$(this).outerHeight();
      e=t>e?t:e
    }),
      $(".ProductItem  .ProductItem__Wrapper").css("height",e)
  });  
},500)



$(window).resize(function() {
  $(".ProductItem  .ProductItem__Wrapper").each(function(){
  $(".ProductItem  .ProductItem__Wrapper").css("height","auto");
  var e=-1;
  $(".ProductItem  .ProductItem__Wrapper").each(function(){
    var t=$(this).outerHeight();
    e=t>e?t:e
  }),
    $(".ProductItem  .ProductItem__Wrapper").css("height",e)
});
})
// var $height = $('.Product--medium .Product__Slideshow').height();
// $('.Product__Gallery--withThumbnails .Product__SlideshowNav--thumbnails').css('height', $height + 10);

